module.exports = __webpack_public_path__ + "img/dados_geometricos.c3cd3155.svg";